export default __webpack_public_path__ + "static/media/8.0eee4a28.jpg";